import React from 'react';
import { Box, Typography, Button, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import ChatList from '../components/chat/ChatList';
import AppLayout from '../components/layout/AppLayout';
import { Add as AddIcon } from '@mui/icons-material';

const ChatsPage: React.FC = () => {
  return (
    <AppLayout>
      <Box sx={{ maxWidth: 1000, mx: 'auto' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4">My Chats</Typography>
          <Button
            variant="contained"
            component={Link}
            to="/new-chat"
            startIcon={<AddIcon />}
          >
            New Chat
          </Button>
        </Box>
        <Divider sx={{ mb: 3 }} />
        <ChatList />
      </Box>
    </AppLayout>
  );
};

export default ChatsPage;
